import { BaseLayout, type NavSection } from './BaseLayout';
import {
  LayoutDashboard,
  Building2,
  Megaphone,
  ImagePlus,
  LayoutTemplate,
  Tv,
  BarChart3,
  Users,
  Settings,
  Map,
  GraduationCap,
  User,
  Bell,
  MessageSquare,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';
import { useMunicipalConfig } from '../../pages/municipal/hooks/useMunicipalConfig';

/**
 * Layout dedicado para Gestores Municipais.
 * Sidebar estruturada com a Suíte Oficial de Comunicação Integrada.
 */
const MUNICIPAL_SECTIONS: NavSection[] = [
  {
    title: null,
    items: [
      { to: '/municipal/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { to: '/municipal/ead', label: 'Video Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Operacional',
    items: [
      { to: '/municipal/escolas', label: 'Escolas', icon: Building2 },
    ],
  },
  {
    title: 'Comunicação',
    items: [
      { to: '/municipal/comunicados', label: 'Comunicados', icon: Megaphone },
      { to: '/municipal/midias', label: 'Banco de Mídias', icon: ImagePlus },
      { to: '/municipal/mural', label: 'Mural Digital', icon: LayoutTemplate },
      { to: '/municipal/estatisticas', label: 'Estatísticas', icon: BarChart3 },
    ],
  },
  {
    title: 'Inteligência',
    items: [
      { to: '/municipal/relatorios', label: 'Relatórios', icon: BarChart3 },
      { to: '/municipal/mapa', label: 'Mapa Estratégico', icon: Map },
    ],
  },
  {
    title: 'Configurações',
    items: [
      { to: '/municipal/configuracoes', label: 'Município', icon: Settings },
      { to: '/municipal/usuarios', label: 'Equipe', icon: Users },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/municipal/perfil', label: 'Meu Perfil', icon: User },
      { to: '/municipal/alertas', label: 'Meus Comunicados', icon: Megaphone },
    ],
  },
];

export function MunicipalLayout() {
  const { brandColor, brandGradient } = useProfileBrandColor('PREFEITO');
  const { config } = useMunicipalConfig();

  return (
    <BaseLayout
      sections={MUNICIPAL_SECTIONS}
      headerTitle="Painel Municipal"
      brandLabel="MUNICIPAL"
      brandSubtitle={config?.nome || 'Gestão da Rede'}
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}
